module.exports = __webpack_public_path__ + "img/thumb_image7.e32205a9.jpg";